import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import LandingPage from "./pages/LandingPage";
import Login from "./components/Login";

// Layouts Dashboard
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";

// Komponen Halaman (Nested Routes)
import PdamBillCalculator from "./components/PdamBillCalculator";
import PosPage from "./pages/PosPage";
import TotalPendapatan from "./pages/TotalPendapatan";
import TrekMotor from "./pages/TrekMotor";
import CCTV from "./pages/CCTV";
import Profile from "./pages/Profile";
import IoTManfaat from "./pages/IoTManfaat";
import DataScienceBisnis from "./pages/DataScienceBisnis";
import KeamananIoT from "./pages/keamanan_iot";
import TipsDepotTeknologi from "./pages/TipsDepotTeknologi";
import Register from "./pages/Register";

import SuperAdminRegister from "./pages/SuperAdminRegister";
import SuperAdminTables from "./pages/SuperAdminTables";
import WebGisPage from "./pages/WebGisPage";
import ManageAccounts from "./pages/ManageAccounts";
import DepotSebaranMap from "./pages/DepotSebaranMap";
import SmartWeatherDashboard from "./pages/SmartWeatherDashboard";
import SmartSensorDetail from "./pages/SmartSensorDetail";
import SmartFarmingDashboard from "./pages/SmartFarmingDashboard";
import GpsTracker from "./pages/GpsTracker";
import SuperAdminWaterUsage from "./pages/SuperAdminWaterUsage";
import SuperAdminWaterUsageComparison from "./pages/SuperAdminWaterUsageComparison";

import "./App.css";
import "./index.css";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loadingAuth, setLoadingAuth] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const isAdmin = localStorage.getItem("is_super_admin") === "true";

    if (token) {
      setIsAuthenticated(true);
      setIsSuperAdmin(isAdmin);
    } else {
      setIsAuthenticated(false);
      setIsSuperAdmin(false);
    }
    setLoadingAuth(false);
  }, []);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
    setIsSuperAdmin(localStorage.getItem("is_super_admin") === "true");
  };

  const DashboardDefaultContent = () => {
    return (
      <div>
        <h2>Selamat Datang di Dashboard Utama!</h2>
        <p>Silakan gunakan menu di sidebar untuk menavigasi.</p>
      </div>
    );
  };

  if (loadingAuth) {
    return <div>Memuat Aplikasi...</div>;
  }

  return (
    <HelmetProvider>
      <Router>
        <Routes>
          {/* Rute Publik / Tanpa Autentikasi */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />
          <Route path="/iot-manfaat" element={<IoTManfaat />} />
          <Route path="/data-science-bisnis" element={<DataScienceBisnis />} />
          <Route path="/keamanan-iot" element={<KeamananIoT />} />
          <Route path="/tips-depot-teknologi" element={<TipsDepotTeknologi />} />
          <Route path="/sebaran-depot" element={<DepotSebaranMap />} />

          {/* Rute untuk Super Admin */}
          {isAuthenticated && isSuperAdmin ? (
            <Route path="/admin/*" element={<AdminDashboard />}>
            <Route path="register" element={<SuperAdminRegister />} />
            <Route path="tables" element={<SuperAdminTables />} />
            <Route path="webgis" element={<WebGisPage />} />
            <Route path="manage-accounts" element={<ManageAccounts />} />
            <Route path="smart-weather" element={<SmartWeatherDashboard />} />
            <Route path="smart-weather/sensor/:sensorId" element={<SmartSensorDetail />} />
            <Route path="smart-farming" element={<SmartFarmingDashboard />} />
            <Route path="gps-tracker" element={<GpsTracker />} />
            <Route path="water-usage" element={<SuperAdminWaterUsage />} />
            <Route path="water-usage-comparison" element={<SuperAdminWaterUsageComparison />} />
            <Route path="" element={<SuperAdminRegister />} />
            </Route>
          ) : (
            <Route
              path="/admin/*"
              element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />}
            />
          )}

          {/* Rute untuk User Biasa */}
          {isAuthenticated && !isSuperAdmin ? (
            <Route path="/dashboard/*" element={<Dashboard />}>
              <Route path="" element={<DashboardDefaultContent />} />
              <Route path="pdam-bill" element={<PdamBillCalculator />} />
              <Route path="pos" element={<PosPage />} />
              <Route path="pendapatan" element={<TotalPendapatan />} />
              <Route path="trek-motor" element={<TrekMotor />} />
              <Route path="cctv" element={<CCTV />} />
              <Route path="profile" element={<Profile />} />
            </Route>
          ) : (
            <Route path="/dashboard/*" element={<Navigate to="/login" replace />} />
          )}

          {!isAuthenticated && <Route path="*" element={<Navigate to="/login" replace />} />}
          {isAuthenticated && !isSuperAdmin && (
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          )}
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;